<template>
  <div class="week-header" :style="style">
    <span>Tydzień {{ week }}</span>
    <div class="week-header__menu">
      <button
        type="button"
        class="week-header__menu-button"
        :data-test-id="`DietWeekHeader__Menu-${week}`"
        :aria-label="`Opcje tygodnia ${week}`"
        @click.stop="emit('toggle')"
      >
        <BaseIcon size="18" name="more_vert" />
      </button>
      <div v-if="open" class="week-header__menu-options">
        <button
          type="button"
          class="week-header__menu-option"
          :data-test-id="`DietWeekHeader__Copy-${week}`"
          @click="emit('copy')"
        >
          <BaseIcon size="16" name="filter_none" />
          Skopiuj tydzień
        </button>
        <button
          v-if="editable"
          type="button"
          class="week-header__menu-option"
          :data-test-id="`DietWeekHeader__Paste-${week}`"
          :disabled="!copiedWeek"
          @click="emit('paste')"
        >
          <BaseIcon size="16" name="queue" />
          Wklej tydzień
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseIcon from '@/components/BaseIcon.vue'

  defineProps<{
    copiedWeek: boolean
    editable: boolean
    open: boolean
    style?: Record<string, string | number>
    week: number
  }>()
  const emit = defineEmits<{ copy: []; paste: []; toggle: [] }>()
</script>

<style scoped>
  .week-header {
    border-right: 2px solid var(--color-main-10);
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    font-family: Montserrat-Medium, sans-serif;
    font-size: 14px;
    color: #fff;
    background: var(--color-main-100);
  }

  .week-header__menu {
    position: absolute;
    top: 0;
    right: 2px;
    bottom: 0;
    display: flex;
    align-items: center;
  }

  .week-header__menu-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    color: #fff;
    cursor: pointer;
    background: transparent;
    border: 0;
  }

  .week-header__menu-button :deep(.base-icon) {
    color: inherit;
  }

  .week-header__menu-options {
    position: absolute;
    top: 28px;
    right: 0;
    z-index: 20;
    min-width: 154px;
    background: #fff;
    box-shadow: 0 1px 6px rgb(155 155 155 / 50%);
  }

  .week-header__menu-option {
    display: flex;
    gap: 6px;
    align-items: center;
    width: 100%;
    padding: 6px 8px;
    font-family: Montserrat-Medium, sans-serif;
    font-size: 12px;
    color: var(--color-primary-text);
    white-space: nowrap;
    cursor: pointer;
    background: transparent;
    border: 0;
  }

  .week-header__menu-option:hover:not(:disabled) {
    background: #f8f8f8;
  }

  .week-header__menu-option:disabled {
    color: var(--color-disabled-text);
    cursor: default;
  }
</style>
